import { FormGroup } from "../form/FormComponents"
import analyzeSerie from '../../../../common/logic/validate/analyzeSerie'

// Setup Use of API
import useApi from '../../hooks/useApi';
import { useQuery } from '@tanstack/react-query'
import useAuth from "../../hooks/useAuth";

const NSerieInput = ({ item, inputId, value, placeholder, autocomplete, setValue, validated, ref, entity, testId }) => {
    
    //Setting up API 
    const { getMe } = useApi();
    const {Auth} = useAuth()
    const currentOrg = Auth.orgId

    //Api Retrieval function to get list
    const getData = async (key) => {
        const orgId = key.queryKey[1]
        const resource = `organization/${orgId}`
        const response = await getMe(resource)
        return response
    }

    //Request to get Countries from API 
    const result = useQuery({
        queryKey: ['orgs', currentOrg],
        queryFn: getData,
        keepPreviousData: true
    })

    // we check the nSerie and we set it to red if it is not valid     
    const serie = analyzeSerie(value)
    let isRed = serie.valid? false: true


    const look ={
        color: isRed? 'red' : 'inherit'
    }
    
    return (
        <FormGroup.Control style={look} type="text" id={inputId || item.id} name={item.id}
            value={value} onChange={setValue} placeholder={placeholder}
            autoComplete="off"
            {...(validated && item.required && { required: true })}
            {...(ref && { ref })}
            data-testid={testId}
        />
    )




}

export default NSerieInput
